import { ChevronDown, TrendingDown, TrendingUp } from "lucide-react";
import React, { Suspense } from "react";
const LazyBar = React.lazy(() =>
  import("react-chartjs-2").then((mod) => ({ default: mod.Bar }))
);
const MarketInsightGraph = () => {
  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        backgroundColor: "#000750",
        padding: 12,
        borderRadius: 8,
      },
    },
    scales: {
      x: {
        grid: { display: false },
        ticks: { font: { size: 10 } },
      },
      y: {
        grid: { color: "#f3f4f6" },
        ticks: { font: { size: 10 } },
      },
    },
  };

  const barData = {
    labels: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
    datasets: [
      {
        label: "This Week",
        data: [12, 15, 13, 18, 16, 19, 14],
        backgroundColor: "#735DFF",
        borderRadius: 8,
      },
      {
        label: "Last Week",
        data: [10, 12, 14, 11, 13, 15, 12],
        backgroundColor: "#FF5A29",
        borderRadius: 8,
      },
    ],
  };

  return (
    <div className="bg-white rounded-lg shadow-sm p-4 sm:p-6">
      <div className="flex items-center justify-between mb-3">
        <h4 className="font-semibold text-text-primary">
          Market Insight Graph
        </h4>

        <button className="text-xs text-text-muted flex items-center gap-1">
          Sort By <ChevronDown className="w-3 h-3" />
        </button>
      </div>

      <div className="flex items-center gap-4 mb-3 text-xs">
        <div>
          <span className="font-bold text-lg">14,642</span>
          <span className="text-status-success inline-flex items-center ml-1">
            <TrendingUp className="w-3 h-3" /> 6.44k
          </span>
          <p className="text-text-muted">This Week</p>
        </div>

        <div>
          <span className="font-bold text-lg">12,326</span>
          <span className="text-status-danger inline-flex items-center ml-1">
            <TrendingDown className="w-3 h-3" /> 2.13k
          </span>
          <p className="text-text-muted">Last Week</p>
        </div>
      </div>

      <div className="h-48">
        <Suspense fallback={<div className="h-48" />}>
          <LazyBar
            data={barData}
            options={{
              ...chartOptions,
              plugins: {
                ...chartOptions.plugins,
                legend: {
                  display: true,
                  position: "bottom",
                  labels: { boxWidth: 12, font: { size: 10 } },
                },
              },
            }}
          />
        </Suspense>
      </div>
    </div>
  );
};
export default MarketInsightGraph;
